import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_thi_e427dc500a: FaireThemeEntity = {
  token: "board_demo_r_wd64rb2zkz_thi_e427dc500a",
  type: "theme",
  retailerToken: "r_wd64rb2zkz",
  name: "Bethany Lutheran Church Dinner Gift Guide",
  description:
    "Highlight your collection of religious board books and sweet nursery decor for families gathering at the Bethany Lutheran Church 16th Annual Pork Loin Dinner.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/528596dc48a61feda89b6cbbad17aed2f2b96569770eb7c35481da07322db17b.png",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/528596dc48a61feda89b6cbbad17aed2f2b96569770eb7c35481da07322db17b.png",
    "https://cdn.faire.com/fastly/98f166ace4ead9680cf5ac398b8465e08ab5a0aeb4f44270efc05223b53dad95.jpeg",
    "https://cdn.faire.com/fastly/41fd7f54a71f6e3122c515fe58e8c8f5fe8460b02173d830e3e7398f51c60cd0.jpeg",
    "https://cdn.faire.com/fastly/4321390e4dbff2b6f9c27f243056012483ffdaec6e80d23c09e76e384333c2ed.jpeg",
    "https://cdn.faire.com/fastly/4228ca63d948a46f4a2c227e5bc86ac8c2e8c55c9ff73ba0f9b459ae044a70b3.jpeg",
    "https://cdn.faire.com/fastly/e8a89fae483e5bd3e2ef9094884d8b168b0bb307e613dd137385927649279184.jpeg",
  ],
  itemCount: 65,
  source: "eric_themes_ideas",
  teaser: "thi_e427dc500a",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
